/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CalculateRecipientsRequest} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/calculate_recipients.pb'
import {CalculateRecipientsResponse} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/calculate_recipients.pb'


export const calculateRecipients = (request: CalculateRecipientsRequest, options?: CashRequestOptions) => post<CalculateRecipientsRequest, CalculateRecipientsResponse>("/2.0/cash/calculate-recipients", request, {...options, rejectOnError: true })